import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { getActiveSection } from '../../../../../selectors/studio';
import { StudioSection } from '../../../../../types/store';
import DefaultLayout from './layouts/DefaultLayout';
import AppsLayout from './layouts/AppsLayout';
import { Props } from './types';

const SelectableDeviationListItem: FC<Props> = props => {
  const activeSection = useSelector(getActiveSection);
  switch (activeSection) {
    case StudioSection.APPS:
    case StudioSection.APPS_UNLISTED:
      return <AppsLayout {...props} />;
    default:
      return <DefaultLayout {...props} />;
  }
};
SelectableDeviationListItem.displayName = 'SelectableDeviationListItem';

export default SelectableDeviationListItem;
